import axios from 'axios'
import { DashboardStorage, runtimeConfig } from '../utils'

const scrubPlatformHeaders = (data, headers) => {
  // In transformRequest, headers is a flat object of headers to be sent
  // Delete these headers if they exist to prevent sending them to Platform API
  if (headers) {
    delete headers['X-Refresh-Token']
    delete headers['Client-Server-Api-Contract-Version']
    delete headers['CSRF-Token']
  }
  return data
}

const createSudoToken = async (description, code, reason) => {
  return await axios.post(
    `${runtimeConfig('public_web_platform_api_url')}/oauth/authorizations`,
    {
      description,
      skip_two_factor: true
    },
    {
      headers: {
        'X-Origin': window.location.origin,
        'Heroku-Two-Factor-Code': code,
        'X-Heroku-Sudo': true,
        'X-Heroku-Sudo-Reason': reason,
        Accept: 'application/vnd.heroku+json; version=3'
      },
      transformRequest: [
        ...axios.defaults.transformRequest,
        scrubPlatformHeaders
      ]
    }
  )
}

const assumeIdentity = async (email, code, reason) => {
  return await axios.get(
    `${runtimeConfig('public_web_platform_api_url')}/account`,
    {
      headers: {
        Authorization: `Bearer ${code}`,
        'X-Origin': window.location.origin,
        'X-Heroku-Sudo': true,
        'X-Heroku-Sudo-User': email,
        'X-Heroku-Sudo-Reason': reason,
        Accept: 'application/vnd.heroku+json; version=3'
      },
      transformRequest: [
        ...axios.defaults.transformRequest,
        scrubPlatformHeaders
      ]
    }
  )
}

const impersonateUser = async formValues => {
  const { email, code, reason } = formValues
  const description = `herokudata-frontend sudo: ${email}`

  try {
    const sudoTokenResponse = await createSudoToken(description, code, reason)

    // Handle both response formats: {access_token: {token: "..."}} or {access_token: "..."}
    const accessToken = sudoTokenResponse.data.access_token
    const token =
      typeof accessToken === 'string' ? accessToken : accessToken?.token

    if (!token) {
      throw new Error('Failed to extract token from sudo response')
    }

    const assumeIdentityResponse = await assumeIdentity(email, token, reason)

    const {
      id,
      name: assumedName,
      email: assumedEmail
    } = assumeIdentityResponse.data
    DashboardStorage.setSessionItem(
      'hk-sudo-data',
      JSON.stringify({
        isAssumed: true,
        sudoReason: reason,
        sudoToken: token,
        user_id: id,
        email: assumedEmail,
        name: assumedName
      })
    )
    window.location.assign('/')
  } catch (e) {
    throw e
  }
}

const whoAmI = async token => {
  return await axios.get(
    `${runtimeConfig('public_web_herokudata_backend')}/whoami`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )
}

const requestPreAuth = async code => {
  return await axios.post(
    `https://api.heroku.com/oauth/authorizations`,
    {
      description: 'dhc 2fa preauth',
      skip_two_factor: true
    },
    {
      headers: {
        Accept: 'application/vnd.heroku+json; version=3',
        'X-Origin': window.location.origin,
        'X-Heroku-Requester': 'dhc',
        'Heroku-Two-Factor-Code': code
      },
      transformRequest: [
        ...axios.defaults.transformRequest,
        scrubPlatformHeaders
      ]
    }
  )
}

const AuthService = {
  createSudoToken,
  assumeIdentity,
  impersonateUser,
  whoAmI,
  requestPreAuth
}

export default AuthService
